import React, { Component } from 'react';
import {Link} from 'react-router-dom'
import {API_BASE_URL, SITE_NAME} from '../../constants'
import {getSessionPhone, setToken, setUserPhone} from '../../storage'
import {NotificationManager, NotificationContainer} from 'react-notifications'
import {NavbarBrand} from '../header'
import axios from 'axios'

class Signup extends Component {


  constructor(props) {
    super(props)
    this.verifyOtp = this.verifyOtp.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this)
    this.state = {otp:''}
    document.title = "Signup Verification - Goods Bill"
  }

  handleInputChange(e) {
    this.setState({
      [e.target.name]: e.target.value
    })
  }
  verifyOtp(e) {
    this.setState({error_response_data: undefined})
    e.preventDefault()
    axios({
      baseURL: API_BASE_URL,
      url:"/verify_signup_otp/",
      method:"POST",
      data: {otp:this.state.otp, phone: getSessionPhone()}
    }).then((response)=>{
      this.setState({verified:true})
      // const token = response.data.token
      // const phone = response.data.phone
      // setToken(token)
      // setUserPhone(phone)
      NotificationManager.success("Verified Phone successfully.. Please Login")
      setTimeout(()=>{
        this.props.history.push("/login/")
      }, 1500)
    }).catch(err=>{

      if(typeof err.response !== "undefined" && typeof err.response.data !== "undefined") {
        this.setState({error_response_data:err.response.data})
      }

    })
  }


  render() {

    let error_response_data = this.state.error_response_data
    let errors
    let otp_error
    if(typeof error_response_data !== "undefined") {
      errors = error_response_data.errors
      if(typeof errors.otp !== "undefined" && errors.otp.length > 0) {
        otp_error = errors.otp[0]
      }
    }

    let submitBtn = <input type="submit" className="btn btn-primary btn-block" value="Submit" />
    if(this.state.verified) {
      submitBtn = <div className="text-success text-center"><b>Please Wait..</b></div>
    }

    return (
      <div>
      <div className="hidden-print">
        <NotificationContainer/>
      </div>
        <nav className="navbar">
          <div className="container">
              <NavbarBrand />
          </div>
        </nav>
        <section>
          <div className="container">
              <div className="row">
                <div className="col-sm-6 col-sm-offset-3">
                  <div className="">
                        <section className="small">
                          <h1 className="text-center">Signup Verification</h1>
                        </section>
                        <form onSubmit={this.verifyOtp}>
                          <div className="form-group">
                            <div>
                            Enter One Time Password(OTP)
                            </div>
                            <div className="text-warning"><b>An SMS has been sent to your phone</b></div>

                            <input type="text" name="otp" className="form-control" onChange={this.handleInputChange} />
                          </div>
                          <span className="text-danger">{otp_error}</span>
                          <div className="form-group">
                            {submitBtn}
                          </div>
                        </form>
                  </div>
                </div>
              </div>
          </div>
        </section>
      </div>
    )
  }
}

export default Signup



// WEBPACK FOOTER //
// ./src/components/auth/signupotp.js